
import { Auth } from "./auth.js";
import { calculatePI } from "./pi_calc.js";
import { getElapsedHtml, countryToChinese, showToast } from "./utils.js";
import { fetchOrdersFromServer } from "./orders_api.js";
/**
 * Efast Workbench - 订单卡片渲染 (询盘 + 订单卡 + 自建订单卡)
 * 从 sales_logic.js 拆分
 */

function renderInquiryCard(inquiry, prepend = true) {
    const inquiryList = document.getElementById("workbench-inquiry-list");
    if (!inquiryList) return;

    // 防止 DOM 重复渲染
    if (document.getElementById(`inq-${inquiry.id}`)) return;

    const card = document.createElement("div");
    card.id = `inq-${inquiry.id}`;
    
    // Parse timestamp and get duration html
    const timestamp = inquiry.timestamp || parseAlibabaTime(inquiry.timeStr);
    const timeInfo = getElapsedHtml(timestamp, inquiry.isUnread);
    
    // Add dynamic classes and styles
    if (timeInfo.isOver24h) {
        card.className = "inquiry-item real-dynamic-item overdue-24h";
        card.style.borderLeft = "4px solid #ef4444";
        card.style.background = "#fff1f2";
    } else {
        card.className = "inquiry-item real-dynamic-item";
        card.style.borderLeft = inquiry.isUnreplied ? "4px solid #f59e0b" : "4px solid #10b981";
        card.style.background = inquiry.isUnreplied ? "#fffbeb" : "#f0fdf4";
    }

    // 建立买家直达会话深度链接 (Request 3)
    const inquiryUrl = inquiry.memberId 
        ? `https://message.alibaba.com/message/default.htm#feedback/all/detail?memberId=${inquiry.memberId}`
        : (inquiry.id.startsWith("inq_") 
           ? `https://message.alibaba.com/message/default.htm#feedback/all/detail?id=${inquiry.id.replace("inq_", "")}`
           : `https://message.alibaba.com/message/default.htm`);

    // 会话跟进分类徽章 (Request 1)
    let classificationLabel = "";
    if (timeInfo.isOver24h) {
        classificationLabel = `<span class="todo-tag urgent" style="background: #ef4444; color: #fff; padding: 2px 6px; border-radius: 4px; font-size: 0.75rem; margin-left: 0.5rem; font-weight: bold;">🔴 严重超时回复</span>`;
    } else if (inquiry.isUnreplied) {
        classificationLabel = `<span class="todo-tag routine" style="background: #f59e0b; color: #fff; padding: 2px 6px; border-radius: 4px; font-size: 0.75rem; margin-left: 0.5rem; font-weight: bold;">🟠 待跟进未回复</span>`;
    } else {
        classificationLabel = `<span class="todo-tag done" style="background: #10b981; color: #fff; padding: 2px 6px; border-radius: 4px; font-size: 0.75rem; margin-left: 0.5rem; font-weight: bold;">🟢 已回复跟进</span>`;
    }

    // 专属负责人角标 (Request 4)
    const salespersonBadge = inquiry.salesperson 
        ? `<span class="inquiry-salesperson" style="background: #e0f2fe; color: #0369a1; padding: 2px 6px; border-radius: 4px; font-size: 0.75rem; font-weight: bold; margin-left: 0.5rem; display: inline-flex; align-items: center; gap: 0.15rem;"><i class="fas fa-user-tie"></i> 负责人: ${inquiry.salesperson}</span>`
        : "";

    card.innerHTML = `
        <div class="inquiry-meta">
            <span class="flag-icon"><i class="fas fa-flag" title="${inquiry.country || 'Unknown'}"></i></span>
            <span class="buyer-name" onclick="window.open('${inquiryUrl}', '_blank')" style="color: ${timeInfo.isOver24h ? '#b91c1c' : (inquiry.isUnreplied ? '#d97706' : '#047857')}; font-weight: bold; cursor: pointer; text-decoration: underline;" title="一键直达该买家的商机详情页">
                ${inquiry.buyerName}
            </span>
            ${classificationLabel}
            ${salespersonBadge}
            ${timeInfo.html}
        </div>
        <p class="inquiry-text" style="border-left: 2px solid ${timeInfo.isOver24h ? '#ef4444' : (inquiry.isUnreplied ? '#f59e0b' : '#10b981')}; padding-left: 0.5rem;">"${inquiry.inquiryText}"</p>
        <div class="item-actions" style="display: flex; gap: 0.5rem; justify-content: flex-end;">
            <a href="${inquiryUrl}" target="_blank" class="btn-small" style="background-color: #64748b; color: white; display: inline-flex; align-items: center; gap: 0.25rem; text-decoration: none; padding: 0.25rem 0.5rem; border-radius: 4px; font-size: 0.8rem;"><i class="fas fa-external-link-alt"></i> 进入会话</a>
            <button class="btn-small btn-ai" onclick="openAiQuote('${inquiry.buyerName}', 'ZF71车载磁吸手机支架', '${inquiry.inquiryText.replace(/'/g, "\\'")}')"><i class="fas fa-robot"></i> AI智能一键生成报价</button>
        </div>
    `;

    if (prepend && inquiryList.firstChild) {
        inquiryList.insertBefore(card, inquiryList.firstChild);
    } else {
        inquiryList.appendChild(card);
    }
}


function renderProductsList(products) {
    if (!products || !Array.isArray(products) || products.length === 0) {
        return `<div class="no-products" style="color: #94a3b8; font-style: italic; font-size: 0.8rem; padding: 4px 0;">暂无商品详情或商品数据未加载</div>`;
    }
    return products.map(p => {
        let titleText = (p.title || p.productTitle || p.productName || "").trim();
        if (titleText === "商品详情") titleText = "";

        const pLink = p.link || p.productLink || "#";
        const truncatedLinkText = pLink.length > 35 ? pLink.substring(0, 35) + "..." : pLink;

        const specsText = (p.skuAttr || p.specs || p.productSpecs || "").trim();
        const skuCheck = specsText.toLowerCase();
        const hasSpecs = specsText && !/^(默认规格|无规格|无|default|none|null)$/i.test(skuCheck);

        const erpModel = p.erpModel || "";
        const imgSrc = erpModel ? '/api/product-image/' + encodeURIComponent(erpModel) : '';
        const imgHtml = erpModel ? '<img src="' + imgSrc + '" style="width:36px;height:36px;object-fit:contain;border-radius:4px;border:1px solid #e2e8f0;flex-shrink:0;margin-right:4px;" onerror="this.style.display=\'none\'">' : '';
        const modelTag = erpModel ? '<span class="product-model-tag" style="font-weight:700;color:#0d9488;font-size:0.75rem;background:#ecfdf5;padding:1px 4px;border-radius:3px;border:1px solid #a7f3d0;display:inline-block;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex-shrink:0;" title="' + erpModel + '">' + erpModel + '</span>' : '';
        const titleSpan = titleText ? '<span class="product-title" style="font-weight: 500; color: #334155; display: inline-block; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-size: 0.825rem;" title="' + titleText + '">' + titleText + '</span>' : '';
        const linkAnchor = pLink !== "#" ? '<a href="' + pLink + '" target="_blank" style="color: #0284c7; font-size: 0.75rem; text-decoration: underline; display: inline-block; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" title="' + pLink + '">' + truncatedLinkText + '</a>' : '';
        const specsTag = hasSpecs ? '<span class="product-specs" style="color: #64748b; font-size: 0.785rem; display: inline-block; max-width: 33%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; text-align: right; vertical-align: middle;" title="' + specsText + '">' + specsText + '</span>' : '';

        const qtyText = p.quantity || p.qty || 1;
        return '<div class="product-item" style="display:flex;justify-content:space-between;align-items:center;border-bottom:1px dashed #f1f5f9;padding:4px 0;gap:0.5rem;">' +
          '<div style="display:flex;align-items:center;gap:0.5rem;overflow:hidden;flex:1;min-width:0;">' +
          imgHtml + modelTag + linkAnchor + specsTag +
          '</div>' +
          '<span class="product-qty" style="font-weight:bold;color:#0f172a;flex-shrink:0;font-size:0.785rem;">x' + qtyText + '</span></div>';
    }).join("");
}


function updatePIFromOrder(orderId) {
    const order = allOrders.find(item => item.id === orderId);
    if (!order) return;

    // 自动填写票据中心表单
    const piBuyer = document.getElementById("pi-buyer");
    const piQty = document.getElementById("pi-qty");
    const piPrice = document.getElementById("pi-price");
    
    if (piBuyer) {
        piBuyer.value = order.buyerName;
        // 触发 buyer 切换逻辑以加载联动
        if (typeof updatePIBuyer === 'function') {
            updatePIBuyer();
        }
    }
    
    if (order.products && order.products.length > 0) {
        const p = order.products[0];
        if (piQty) piQty.value = p.quantity || p.qty || 1000;
        
        let amt = parseFloat((order.amount || "").replace(/[^0-9.]/g, ""));
        let qty = parseInt(p.quantity || p.qty || 1);
        if (piPrice && qty > 0) {
            piPrice.value = (amt / qty).toFixed(2);
        }
    }
    
    if (typeof calculatePI === 'function') {
        calculatePI();
    }
    
    // 切换到票据生成中心
    const navItems = document.querySelectorAll(".nav-item a");
    navItems.forEach(nav => {
        if (nav.innerText.includes("票据生成中心")) {
            nav.click();
        }
    });
}


function renderOrderCard(order, prepend = true, targetEl = null) {
    const todoList = targetEl || document.getElementById("workbench-todo-list");
    if (!todoList) return;
    
    console.log('[Render] 准备渲染订单卡片:', order.id, '自建:', !!order.isSelfOrder);
    
    // 1. 基础字段容错与规范化
    const isSelf = !!order.isSelfOrder;
    const orderId = order.id || '未知单号';
    const displayId = order.orderId || order.id || '未知单号';
    const amount = order.amount || 'US$0.00';
    const buyerName = order.buyerName || '匿名客户';
    const salesperson = order.salesperson || '未分配';
    
    // 2. 倒计时与日期容错
    const shipDate = order.shipDate || "";
    const daysLeft = order.daysLeft != null ? order.daysLeft : (shipDate ? Math.ceil((new Date(shipDate) - new Date()) / 86400000) : 999);
    const isOverdue = daysLeft < 0;
    const isUrgent = daysLeft >= 0 && daysLeft <= 3;

    // 3. 国家翻译兼容 (防止外部函数崩溃)
    let chineseCountry = order.buyerCountryCn || order.buyerCountry || order.shippingCountry || "未知国家";
    if (typeof countryToChinese === 'function') {
        var countryField = order.buyerCountry || order.shippingCountry || "";
        try { chineseCountry = countryToChinese(countryField); } catch(e){}
    }

    // 4. 清除残留重复DOM
    var dup = document.getElementById('todo-' + orderId);
    if (dup) dup.remove();

    // 5. 样式计算
    let borderColor = "#10b981"; // 默认绿色
    let bgColor = "#fafdfb";
    if (isSelf) { borderColor = "#9333ea"; bgColor = "#faf5ff"; } // 自建紫色
    else if (isOverdue) { borderColor = "#ef4444"; bgColor = "#fff5f5"; } // 逾期红色
    else if (isUrgent) { borderColor = "#f97316"; bgColor = "#fffaf5"; } // 紧急橙色

    const li = document.createElement("li");
    li.id = `todo-${orderId}`;
    li.style.cssText = `border-left:4px solid ${borderColor}; background:${bgColor}; padding:12px; margin-bottom:12px; border-radius:8px; box-shadow:0 1px 3px rgba(0,0,0,0.05); list-style:none;`;

    // 6. 视觉标签
    const badgeHtml = isSelf 
        ? `<span style="background:#f5f3ff; color:#7c3aed; padding:2px 6px; border-radius:4px; font-size:10px; font-weight:700; border:1px solid #ddd6fe; margin-right:6px;">自建订单</span>`
        : `<span style="background:#f0fdf4; color:#16a34a; padding:2px 6px; border-radius:4px; font-size:10px; font-weight:700; border:1px solid #bbf7d0; margin-right:6px;">国际站</span>`;

    const orderLink = isSelf ? '#' : `https://biz.alibaba.com/ta/detail.htm?orderId=${orderId}`;

    li.innerHTML = `
        <div class="order-card-main" style="display: flex; flex-direction: column; gap: 6px;">
            <!-- 第一行：标记、订单号、负责人、金额 -->
            <div class="order-card-row1" style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px dashed #e2e8f0; padding-bottom: 6px;">
                <div style="display: flex; align-items: center; gap: 0.5rem;">
                    ${badgeHtml}
                    <a class="order-id-link" href="${orderLink}" target="_blank" title="一键直达详情页" style="font-weight: bold; color: ${isSelf ? '#9333ea' : '#0284c7'}; text-decoration: underline; font-size: 0.9rem;">
                        订单号: ${displayId}
                    </a>
                    <span class="order-salesperson" style="background: #e0f2fe; color: #0369a1; padding: 2px 6px; border-radius: 4px; font-size: 0.75rem; font-weight: bold; display: inline-flex; align-items: center; gap: 0.25rem;">
                        <i class="fas fa-user-tie"></i> ${salesperson}
                    </span>
                </div>
                <div class="order-card-right">
                    <span class="order-amount-tag" style="font-weight: 800; color: #be123c; font-size: 1.05rem;">${amount}</span>
                </div>
            </div>
            <!-- 第二行：国旗、星级、买家名、倒计时、国家 -->
            <div class="order-card-row2" style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 0.6rem; font-size: 0.85rem; padding: 2px 0; width: 100%;">
                <div style="display: flex; align-items: center; flex-wrap: wrap; gap: 0.6rem;">
                    ${order.buyerFlagUrl ? `<img src="${order.buyerFlagUrl}" style="width:20px;height:14px;object-fit:contain;flex-shrink:0;border:1px solid #e2e8f0;border-radius:2px;" title="${chineseCountry}">` : ''}
                    ${order.buyerLevel ? `<span style="background:#fef3c7;color:#d97706;padding:2px 6px;border-radius:4px;font-size:12px;font-weight:700;">${order.buyerLevel}</span>` : ''}
                    <span style="font-weight: 800; color: #1e293b;">${buyerName}</span>
                    ${daysLeft == null && shipDate ? `<span style="font-size:0.75rem;background:#dbeafe;color:#1e40af;padding:2px 6px;border-radius:4px;font-weight:bold;">${shipDate}前发货</span>` : daysLeft >= 900 ? `<span style="font-size:0.75rem;background:#e2e8f0;color:#475569;padding:2px 6px;border-radius:4px;font-weight:bold;">发货日期待确认</span>` : isOverdue ? `<span style="font-size:0.75rem;background:#fee2e2;color:#ef4444;padding:2px 6px;border-radius:4px;border:1px solid #fecaca;font-weight:bold;">⚠ 已逾期 ${Math.abs(daysLeft)} 天</span>` : isUrgent ? '<span style="font-size:0.75rem;background:#ffedd5;color:#ea580c;padding:2px 6px;border-radius:4px;border:1px solid #fed7aa;font-weight:bold;">还剩 ' + daysLeft + ' 天</span>' + (shipDate ? ' <span style="font-size:0.7rem;color:#92400e;">· ' + shipDate.replace(/^\\d{4}-/,'').replace('-','月') + '日前发货</span>' : '') : '<span style="font-size:0.75rem;background:#ecfdf5;color:#16a34a;padding:2px 6px;border-radius:4px;border:1px solid #a7f3d0;font-weight:bold;">还剩 ' + daysLeft + ' 天</span>' + (shipDate ? ' <span style="font-size:0.7rem;color:#64748b;">· ' + shipDate.replace(/^\\d{4}-/,'').replace('-','月') + '日前发货</span>' : '')}
                </div>
                <span class="order-destination" style="font-weight: bold; color: #1e293b; background: #f1f5f9; border: 1px solid #cbd5e1; padding: 2px 6px; border-radius: 4px; font-size: 0.75rem;">
                    ${chineseCountry}
                </span>
            </div>

            <!-- 第三行：产品详情列表 (恢复深度渲染) -->
            <div class="order-card-row3" style="padding: 4px 0;">
                ${renderProductsList(order.products)}
            </div>

            <!-- 第四行：功能交互区 -->
            <div class="order-card-row4" style="display: flex; justify-content: space-between; align-items: center; padding-top: 4px; border-top: 1px dashed #e2e8f0; margin-top: 4px;">
                <div style="display: flex; gap: 0.5rem;">
                    <button class="btn-small btn-crm" onclick="importOrderToCRM('${orderId}')" style="background: #f59e0b; color: white; border: none; padding: 4px 8px; border-radius: 4px; cursor: pointer; font-size: 0.75rem; font-weight: bold; display: flex; align-items: center; gap: 4px;">
                        <i class="fa-solid fa-address-book"></i> 导入CRM
                    </button>
                    <button class="btn-small btn-invoice" onclick="generateInvoice('${orderId}')" style="background: #10b981; color: white; border: none; padding: 4px 8px; border-radius: 4px; cursor: pointer; font-size: 0.75rem; font-weight: bold; display: flex; align-items: center; gap: 4px;">
                        <i class="fa-solid fa-file-invoice"></i> 生成发票
                    </button>
                    <button class="btn-small btn-custom" onclick="openCustomOrderFromOrder('${orderId}')" style="background: #f59e0b; color: white; border: none; padding: 4px 8px; border-radius: 4px; cursor: pointer; font-size: 0.75rem; font-weight: bold; display: flex; align-items: center; gap: 4px;">
                        <i class="fa-solid fa-pen-ruler"></i> 定制
                    </button>
                    <button class="btn-small btn-sourcing" onclick="openPurchaseOrderFromOrder('${orderId}')" style="background: #0d9488; color: white; border: none; padding: 4px 8px; border-radius: 4px; cursor: pointer; font-size: 0.75rem; font-weight: bold; display: flex; align-items: center; gap: 4px;">
                        <i class="fas fa-cart-plus"></i> 去采购
                    </button>
                    <button class="btn-small btn-ship" onclick="openShenhanFromOrder('${orderId}')" style="background: #dc2626; color: white; border: none; padding: 4px 8px; border-radius: 4px; cursor: pointer; font-size: 0.75rem; font-weight: bold; display: flex; align-items: center; gap: 4px;">
                        <i class="fa-solid fa-truck"></i> 去发货
                    </button>
                    <button id="btn-perf-${orderId}" class="btn-small btn-perf" onclick="addToPerformance('${orderId}')" style="background: #0891b2; color: white; border: none; padding: 4px 8px; border-radius: 4px; cursor: pointer; font-size: 0.75rem; font-weight: bold; display: flex; align-items: center; gap: 4px;">
                        <i class="fa-solid fa-chart-line"></i> 纳入业绩
                    </button>
                </div>
                ${isSelf ? `
                    <button class="btn-small btn-correct" onclick="deleteSelfOrder('${orderId}')" style="background: transparent; color: #ef4444; border: 1px solid #fecaca; padding: 4px 8px; border-radius: 4px; cursor: pointer; font-size: 0.75rem; font-weight: bold; display: flex; align-items: center; gap: 4px;">
                        <i class="fa-solid fa-trash"></i> 删除订单
                    </button>
                ` : `
                    <button class="btn-small btn-correct" onclick="correctOrder('${orderId}')" style="background: transparent; color: #ef4444; border: 1px solid #fecaca; padding: 4px 8px; border-radius: 4px; cursor: pointer; font-size: 0.75rem; font-weight: bold; display: flex; align-items: center; gap: 4px;">
                        <i class="fa-solid fa-triangle-exclamation"></i> 订单纠错
                    </button>
                `}
            </div>
        </div>
    `;

    // 统一按排好的顺序添加
    todoList.appendChild(li);
    // 检查是否已纳入业绩，更新按钮状态
    if (window._performanceIds && window._performanceIds.includes(orderId)) {
        const perfBtn = document.getElementById('btn-perf-' + orderId);
        if (perfBtn) { perfBtn.disabled = true; perfBtn.textContent = '✓ 已纳入'; perfBtn.style.opacity = '0.6'; }
    }
    updateTodoBadge();
}

// 国家全名到中文常见简称映射字典
const COUNTRY_TO_CHINESE = {
    "United States": "美国", "USA": "美国", "US": "美国", "Germany": "德国", "Netherlands": "荷兰",
    "China": "中国", "Spain": "西班牙", "France": "法国", "United Kingdom": "英国", "UK": "英国", "Great Britain": "英国",
    "Ghana": "加纳", "Senegal": "塞内加尔", "Mali": "马里", "Nigeria": "尼日利亚", "Kenya": "肯尼亚",
    "Tanzania": "坦桑尼亚", "Egypt": "埃及", "Morocco": "摩洛哥", "Italy": "意大利", "Belgium": "比利时",
    "Poland": "波兰", "Sweden": "瑞典", "Norway": "挪威", "Denmark": "丹麦", "Finland": "芬兰",
    "Portugal": "葡萄牙", "Austria": "奥地利", "Switzerland": "瑞士", "Czech Republic": "捷克",
    "Romania": "罗马尼亚", "Hungary": "匈牙利", "Brazil": "巴西", "Argentina": "阿根廷", "Colombia": "哥伦比亚",
    "Chile": "智利", "Peru": "秘鲁", "Australia": "澳大利亚", "New Zealand": "新西兰", "Japan": "日本",
    "South Korea": "韩国", "Korea": "韩国", "India": "印度", "Pakistan": "巴基斯坦", "Bangladesh": "孟加拉国",
    "Sri Lanka": "斯里兰卡", "Saudi Arabia": "沙特", "UAE": "阿联酋", "United Arab Emirates": "阿联酋",
    "Qatar": "卡塔尔", "Kuwait": "科威特", "Bahrain": "巴林", "Oman": "阿曼", "Jordan": "约旦",
    "Israel": "以色列", "Turkey": "土耳其", "Russia": "俄罗斯", "Ukraine": "乌克兰", "Kazakhstan": "哈萨克斯坦",
    "Indonesia": "印尼", "Malaysia": "马来西亚", "Thailand": "泰国", "Vietnam": "越南", "Philippines": "菲律宾",
    "Singapore": "新加坡", "Taiwan": "中国台湾", "Hong Kong": "中国香港"
};


function toggleTodo(todoId) {
    const todoEl = document.getElementById(`chk-todo-${todoId}`);
    if (todoEl && todoEl.checked) {
        todoEl.nextElementSibling.classList.add("completed");
    } else if (todoEl) {
        todoEl.nextElementSibling.classList.remove("completed");
    }
    updateTodoBadge();
}


function toggleRealTodo(orderId) {
    const todoEl = document.getElementById(`chk-real-${orderId}`);
    if (todoEl && todoEl.checked) {
        todoEl.nextElementSibling.classList.add("completed");
    } else if (todoEl) {
        todoEl.nextElementSibling.classList.remove("completed");
    }
    updateTodoBadge();
}


function updateTodoBadge() {
    const staticCheckboxes = document.querySelectorAll('#workbench-todo-list input[type="checkbox"]').length;
    const checkedCheckboxes = document.querySelectorAll('#workbench-todo-list input[type="checkbox"]:checked').length;
    const remaining = staticCheckboxes - checkedCheckboxes;

    const badge = document.getElementById("todo-badge-count");
    if (badge) {
        badge.innerText = remaining;
        if (remaining === 0) {
            badge.style.backgroundColor = "#22c55e";
            badge.innerText = "✓";
        } else {
            badge.style.backgroundColor = "";
        }
    }
}

async function importOrderToCRM(orderId) {
    const order = allOrders.find(item => item.id === orderId);
    if (!order) {
        alert('未找到订单数据');
        return;
    }
    
    // 星级映射
    function mapBuyerLevel(level) {
        if (!level) return 'L0';
        if (/^L[0-4]$/i.test(level)) return level.toUpperCase();
        return 'L3';
    }
    
    // 检查是否已导入
    try {
        const token = typeof Auth !== 'undefined' ? Auth.getToken() : localStorage.getItem('efast_token');
        const checkResp = await fetch('/api/customers', {
            headers: { 'Authorization': 'Bearer ' + token }
        });
        if (!checkResp.ok) throw new Error('获取客户列表失败');
        
        const checkData = await checkResp.json();
        const existing = checkData.customers.find(c => 
            c.company === order.buyerName || 
            (c.customFields && c.customFields.some(f => f.content === order.id))
        );
        
        if (existing) {
            if (!confirm('客户 "' + order.buyerName + '" 已存在于CRM中，是否要更新订单信息？')) {
                return;
            }
            // 更新现有客户的订单信息和地址
            const updateFields = {
                customFields: [
                    ...(existing.customFields || []).filter(f => !['最近订单', '订单金额', '发货截止', '采购产品'].includes(f.label)),
                    { label: '最近订单', content: order.id },
                    { label: '订单金额', content: order.amount },
                    { label: '发货截止', content: order.shipDate || '' }
                ]
            };
            
            // 如果有产品信息
            if (order.products && order.products.length > 0) {
                const productNames = order.products.map(p => p.title || p.productTitle || '').filter(Boolean).join('; ');
                if (productNames) {
                    updateFields.customFields.push({ label: '采购产品', content: productNames });
                }
            }
            
            // 如果原客户没有地址，且订单有地址，则更新
            if (!existing.address && order.buyerAddress) {
                updateFields.address = order.buyerAddress;
            }
            // 如果原客户没有电话，且订单有电话，则更新
            if (!existing.phone && order.buyerPhone) {
                updateFields.phone = order.buyerPhone;
            }
            // 如果原客户没有收货人，且订单有收货人，则更新
            if (!existing.consignee && order.buyerConsignee) {
                updateFields.consignee = order.buyerConsignee;
            }
            
            const updateResp = await fetch('/api/customers/' + existing.id, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                },
                body: JSON.stringify(updateFields)
            });
            if (updateResp.ok) {
                alert('客户订单信息已更新');
            }
            return;
        }
        
        // 判断公司名是否为个人名（简单判断：不含Ltd/Inc/Co等公司关键词）
        const companyKeywords = ['ltd', 'inc', 'co.', 'corp', 'llc', 'gmbh', 's.a.', 'company', 'limited'];
        const isCompanyName = companyKeywords.some(kw => (order.buyerName || '').toLowerCase().includes(kw));
        
        // 收货人/地址 直接从订单字段获取（V5.0插件已分离）
        const consignee = order.buyerConsignee || '';
        const cleanAddress = order.buyerAddress || order.buyerCountry || '';
        
        // 构建客户数据
        const customerData = {
            star: mapBuyerLevel(order.buyerLevel),
            country: order.buyerCountryCn || '',
            company: order.buyerName || '',
            contact: order.buyerName || '',  // 联系人默认为买家名
            consignee: consignee,  // 收货人
            phone: order.buyerPhone || '',    // 从订单获取电话
            email: '',
            address: cleanAddress,  // 清理后的地址
            customFields: [
                { label: '最近订单', content: order.id },
                { label: '订单金额', content: order.amount },
                { label: '发货截止', content: order.shipDate || '' }
            ]
        };
        
        // 添加产品信息到自定义字段
        if (order.products && order.products.length > 0) {
            const productNames = order.products.map(p => p.title || p.productTitle || '').filter(Boolean).join('; ');
            if (productNames) {
                customerData.customFields.push({ label: '采购产品', content: productNames });
            }
        }
        
        // 导入到CRM
        const resp = await fetch('/api/customers', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(customerData)
        });
        
        if (resp.ok) {
            alert('客户 "' + order.buyerName + '" 已成功导入CRM！');
        } else {
            const err = await resp.json();
            alert('导入失败: ' + (err.error || '未知错误'));
        }
    } catch (err) {
        alert('导入失败: ' + err.message);
    }
}

/**
 * ==========================================
 * 9. 双向跨沙箱联动数据接收中心 (PostMessage Router)
 * ==========================================
 */
window.addEventListener("message", (event) => {
    // 严格的安全过滤：仅监听来自我们插件桥接脚本发出的合法通信
    if (event.data && event.data.source === "efast_extension_link") {
        const payload = event.data.payload;
        console.log("[Efast Workbench] 数据接收端拦截到插件投递的真实数据:", payload);
        window.handleExtensionEvent(payload);
    }
});

// 将产品映射应用到订单（阿里链接 → ERP型号）
var _mappingsPromise = null;

function ensureMappingsLoaded() {
    if (!_mappingsPromise) {
        _mappingsPromise = Auth.apiFetch('/api/product-mappings').then(function(data) {
            _mappingCache = data.mappings || [];
            console.log('[Mapping] 加载了 ' + _mappingCache.length + ' 条产品映射');
            return _mappingCache;
        }).catch(function() {
            _mappingsPromise = null;
            return [];
        });
    }
    return _mappingsPromise;
}

// 应用产品型号映射到订单

function applyProductMappings(order) {
    return ensureMappingsLoaded().then(function(mappings) {
        if (!order.products || !order.products.length) return;
        order.products.forEach(function(p) {
            if (!p.link) return;
            // 精确匹配URL
            var exact = mappings.find(function(m) { return m.aliUrl === p.link; });
            if (exact) {
                p.erpModel = exact.erpModel;
                console.log('[Mapping] 产品 ' + (p.title || '').substring(0,30) + ' → ' + exact.erpModel);
                return;
            }
            // 模糊匹配：URL包含
            var fuzzy = mappings.find(function(m) {
                return p.link.indexOf(m.aliUrl) !== -1 || (m.aliUrl && m.aliUrl.indexOf(p.link) !== -1);
            });
            if (fuzzy) {
                p.erpModel = fuzzy.erpModel;
                console.log('[Mapping] 产品 (fuzzy) ' + (p.title || '').substring(0,30) + ' → ' + fuzzy.erpModel);
            }
        });
    });
}


// ===== 纳入业绩 =====
var _performanceIds = [];
function loadPerformanceIds() {
    return fetch('/api/performance', { headers: { 'Authorization': 'Bearer ' + (typeof Auth !== 'undefined' && Auth.getToken ? Auth.getToken() : '') } })
        .then(function(r) { if (r.ok) return r.json(); return []; })
        .then(function(data) {
            _performanceIds = data.map(function(p) { return p.id; });
            window._performanceIds = _performanceIds;
        }).catch(function() {});
}
async function addToPerformance(orderId) {
    var order = window.allOrders ? window.allOrders.find(function(o) { return o.id === orderId; }) : null;
    if (!order) { showToast('加入专案失败', '未找到订单数据', 'error'); return; }
    if (_performanceIds.includes(orderId)) { alert('该订单已纳入业绩'); return; }
    // 将 salesperson 从别名映射为 displayName
    var sp = order.salesperson || '';
    if (typeof mapAliasToDisplayName === 'function') {
        try { sp = await mapAliasToDisplayName(sp); } catch(e) {}
    }
    fetch('/api/performance', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + (typeof Auth !== 'undefined' && Auth.getToken ? Auth.getToken() : '') },
        body: JSON.stringify({
            id: order.id,
            amount: order.amount || '',
            buyerName: order.buyerName || '',
            shipDate: order.shipDate || '',
            salesperson: sp,
            buyerCountry: order.buyerCountry || '',
            products: order.products || []
        })
    })
        .then(function(r) { return r.json(); })
        .then(function() {
            _performanceIds.push(orderId);
            window._performanceIds = _performanceIds;
            var btn = document.getElementById('btn-perf-' + orderId);
            if (btn) { btn.disabled = true; btn.textContent = '\u2714 已纳入'; btn.style.opacity = '0.6'; }
            fetchOrdersFromServer().then(function(serverOrders) {
                if (Array.isArray(serverOrders) && serverOrders.length > 0) {
                    window.allOrders = serverOrders.filter(function(o) { return !o.source || o.source === "overview"; });
                }
                var alibabaOrders = window.allOrders.filter(function(o) { return !o.isSelfOrder; });
                var selfOrders = window.allOrders.filter(function(o) { return o.isSelfOrder; });
                var todoList = document.getElementById("workbench-todo-list");
                if (todoList) { todoList.innerHTML = ""; alibabaOrders.forEach(function(ord) { try { renderOrderCard(ord, false); } catch(e) {} }); }
                var selfList = document.getElementById("self-order-list");
                if (selfList) { selfList.innerHTML = ""; selfOrders.forEach(function(ord) { try { renderOrderCard(ord, false, selfList); } catch(e) {} }); }
            });
        }).catch(function(e) { console.error('纳入业绩失败:', e); });
}
loadPerformanceIds();
async function batchImportAllToCRM() {
    var orders = window.allOrders || [];
    if (!orders.length) { alert("暂无订单数据"); return; }
    
    // Deduplicate by buyerName
    var seen = {};
    var buyers = [];
    orders.forEach(function(o) {
        if (o.buyerName && !seen[o.buyerName]) {
            seen[o.buyerName] = true;
            buyers.push(o);
        }
    });
    
    if (!buyers.length) { alert("暂无客户可导入"); return; }
    
    var token = Auth.getToken();
    var created = 0, updated = 0, failed = 0;
    
    // Get existing customers
    var resp = await fetch("/api/customers", { headers: { "Authorization": "Bearer " + token } });
    if (!resp.ok) { alert("获取CRM客户列表失败"); return; }
    var crmData = await resp.json();
    var existingCustomers = crmData.customers || [];
    
    for (var i = 0; i < buyers.length; i++) {
        var order = buyers[i];
        try {
            var existing = existingCustomers.find(function(c) {
                return c.company === order.buyerName;
            });
            
            var baseData = {
                company: order.buyerName || "",
                country: order.buyerCountryCn || order.buyerCountry || '',
                contact: order.buyerName || "",
                phone: order.buyerPhone || "",
                address: order.buyerAddress || order.buyerCountry || "",
                consignee: order.buyerConsignee || "",
                customFields: [
                    { label: "最近订单", content: order.id },
                    { label: "订单金额", content: order.amount },
                    { label: "发货截止", content: order.shipDate || "" }
                ]
            };
            
            if (order.products && order.products.length) {
                var names = order.products.map(function(p) { return p.title || ""; }).filter(Boolean).join("; ");
                if (names) baseData.customFields.push({ label: "采购产品", content: names });
            }
            
            var r;
            if (existing) {
                r = await fetch("/api/customers/" + existing.id, {
                    method: "PUT",
                    headers: { "Content-Type": "application/json", "Authorization": "Bearer " + token },
                    body: JSON.stringify(baseData)
                });
                if (r.ok) updated++;
                else failed++;
            } else {
                baseData.star = "L0";
                baseData.email = "";
                r = await fetch("/api/customers", {
                    method: "POST",
                    headers: { "Content-Type": "application/json", "Authorization": "Bearer " + token },
                    body: JSON.stringify(baseData)
                });
                if (r.ok) created++;
                else failed++;
            }
        } catch(e) { failed++; }
    }
    
    alert("导入完成！\n新增 " + created + " 个客户\n更新 " + updated + " 个客户\n" + (failed ? "失败 " + failed + " 个" : ""));
}



// ===== 专案管理联动逻辑 =====
async function addOrderToProject(orderId) {
    const order = allOrders.find(item => item.id === orderId);
    if (!order) { showToast('加入专案失败', '未找到订单数据', 'error'); return; }

    try {
        const token = Auth.getToken();
        // 1. 查找或导入客户到 CRM
        const checkResp = await fetch('/api/customers', { headers: { 'Authorization': 'Bearer ' + token } });
        const checkData = await checkResp.json();
        let customer = (checkData.customers || []).find(c => c.company === order.buyerName);

        if (!customer) {
            console.log('[Project] 客户不存在，正在自动导入 CRM...');
            // 自动构建并导入
            const customerData = {
                star: 'L3',
                country: order.buyerCountryCn || '',
                company: order.buyerName || '',
                contact: order.buyerName || '',
                phone: order.buyerPhone || '',
                address: order.buyerAddress || '',
                customFields: [{ label: '首个专案订单', content: order.id }]
            };
            const importResp = await fetch('/api/customers', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
                body: JSON.stringify(customerData)
            });
            const importResult = await importResp.json();
            customer = importResult.customer;
        }

        if (!customer || !customer.id) throw new Error('无法定位或创建 CRM 客户');

        // 2. 标记为专案客户
        const projectResp = await fetch(`/api/customers/${customer.id}/project`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
            body: JSON.stringify({ isProject: true })
        });

        if (!projectResp.ok) throw new Error("标记专案客户失败");

        // 3. 保存订单到专案订单库
        const orderResp = await fetch("/api/project-orders", {
            method: "POST",
            headers: { "Content-Type": "application/json", "Authorization": "Bearer " + token },
            body: JSON.stringify({
                id: order.id,
                buyerName: order.buyerName || "",
                amount: order.amount || "",
                status: order.status || "",
                salesperson: order.salesperson || "",
                buyerCountry: order.buyerCountry || "",
                orderDate: order.orderDate || "",
                shipDate: order.shipDate || "",
                products: order.products || [],
                buyerAddress: order.buyerAddress || ""
            })
        });

        if (orderResp.ok) {
            showToast("加入专案成功", "客户 " + order.buyerName + " 订单已加入专案追踪", "success");
            if (typeof ProjectTracking !== "undefined" && document.getElementById("view-project-tracking").classList.contains("active")) {
                ProjectTracking.init();
            }
        } else {
            throw new Error("保存专案订单失败");
        }
    } catch (err) {
        showToast('操作失败', err.message, 'error');
    }
}
function correctOrder(orderId) {
    if (window.__efastSyncInProgress) {
        alert("⚠️ 当前后台有同步任务在执行中，请等候同步完毕再点击纠错！");
        return;
    }
    const consoleLog = document.getElementById("sync-console-log");
    if (consoleLog) {
        const p = document.createElement("p");
        p.className = "console-line warning";
        p.innerHTML = `[${new Date().toLocaleTimeString()}] 正在对订单号 ${orderId} 强制发起详情页穿透纠错拉取...`;
        consoleLog.appendChild(p);
        consoleLog.scrollTop = consoleLog.scrollHeight;
    }
    // 发送 message 给 workbench_bridge.js，中转触发插件的 CORRECT_ORDER
    window.postMessage({ source: "efast_workbench_request", type: "CORRECT_ORDER", orderId: orderId }, "*");
}




// window bridges for template onclick handlers
window.batchImportAllToCRM = batchImportAllToCRM;

window.correctOrder = correctOrder;


async function generateInvoice(orderId) {
  var orders = window.allOrders || [];
  var order = orders.find(function(o) { return o.id === orderId; });
  if (!order) { alert('未找到订单数据'); return; }
  // Apply product mappings first to get erpModel
  await applyProductMappings(order);
  // Extract products with model
  var products = (order.products || []).map(function(p) {
    return { model: p.erpModel || '', quantity: parseInt(p.qty) || 1, link: p.link || '' };
  }).filter(function(p) { return p.model; });
  if (products.length === 0) {
    alert('该订单没有可匹配的产品型号，请先在产品中心建立型号映射');
    return;
  }
  // Store order data for invoice prefill
  sessionStorage.setItem('efast_invoice_prefill', JSON.stringify({
    buyerName: order.buyerName || '',
    buyerConsignee: order.buyerConsignee || '',
    buyerPhone: order.buyerPhone || '',
    buyerAddress: order.buyerAddress || '',
    products: products
  }));
  // Navigate to invoice builder
  if (typeof openInvoiceBuilder === 'function') {
    openInvoiceBuilder();
  } else {
    alert('票据模块未加载，请先刷新页面');
  }
}

window.addOrderToProject = addOrderToProject;
window.addToPerformance = addToPerformance;
window.importOrderToCRM = importOrderToCRM;
window.generateInvoice = generateInvoice;

async function deleteSelfOrder(orderId) {
  if (!confirm("确定删除此自建订单？此操作不可撤销。")) return;
  try {
    var token = (typeof Auth !== 'undefined' && Auth.getToken) ? Auth.getToken() : '';
    await fetch('/api/orders/' + orderId, { method: 'DELETE', headers: { 'Authorization': 'Bearer ' + token } });
    if (window._reloadOrders) await window._reloadOrders();
    if (typeof loadStoredSalesData === 'function') loadStoredSalesData();
  } catch (e) {
    console.error("删除订单失败:", e);
  }
}

window.deleteSelfOrder = deleteSelfOrder;
export { renderOrderCard, renderProductsList, updatePIFromOrder, renderInquiryCard, ensureMappingsLoaded, applyProductMappings, COUNTRY_TO_CHINESE };
